module.exports = __webpack_public_path__ + "static/img/6.2ccc591.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/1/zh/6.png
// module id = osDq
// module chunks = 0